import { render, staticRenderFns } from "./enquiry-details.vue?vue&type=template&id=c45dc44c&"
import script from "./enquiry-details.vue?vue&type=script&lang=ts&"
export * from "./enquiry-details.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports